import { fundingRateIsCurrent } from './fx.js';
/** Payment currency never falls back to a different currency when valuation is unavailable. */
export function fundingCurrencyContext(currency, snapshot, now) {
    const decimals = /^[A-Z]{3}$/.test(currency)
        ? new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions()
            .maximumFractionDigits
        : undefined;
    const fx = readFundingFx(snapshot);
    const ready = decimals !== undefined &&
        decimals >= 0 &&
        decimals <= 4 &&
        fx !== null &&
        fundingRateIsCurrent(fx, now) &&
        fx.ratesD9[currency] !== undefined;
    return { currency, decimals: decimals ?? 2, fx, status: ready ? 'ready' : 'unavailable' };
}
/** SDK boundary for projected backend DTOs; malformed rates cannot become payment authority. */
export function readFundingFx(value) {
    if (!value ||
        typeof value !== 'object' ||
        !('base' in value) ||
        value.base !== 'USD' ||
        !('convention' in value) ||
        value.convention !== 'usdc-usd-reference' ||
        !('source' in value) ||
        value.source !== 'exchange-rate-api' ||
        !('observedAt' in value) ||
        typeof value.observedAt !== 'string' ||
        !('expiresAt' in value) ||
        typeof value.expiresAt !== 'string' ||
        !('ratesD9' in value) ||
        !value.ratesD9 ||
        typeof value.ratesD9 !== 'object' ||
        Array.isArray(value.ratesD9))
        return null;
    const ratesD9 = {};
    for (const [code, rate] of Object.entries(value.ratesD9)) {
        if (!/^[A-Z]{3}$/.test(code) || typeof rate !== 'string' || !/^[1-9]\d{0,19}$/.test(rate))
            return null;
        ratesD9[code] = rate;
    }
    if (ratesD9.USD !== '1000000000')
        return null;
    return {
        base: value.base,
        convention: value.convention,
        source: value.source,
        observedAt: value.observedAt,
        expiresAt: value.expiresAt,
        ratesD9,
    };
}
